<h1 class="ibk-title">Declara los socios de tu empresa:</h1>
<p class="ibk-title-description">
  Considera a los accionistas que conforman el total de tu empresa. Si el representante legal es accionista también deberás incluirlo.
</p>

<ng-container *ngFor="let pForm of getControls(); let i = index" [formGroup]="pForm">
  <div class="ba-field-group">
    <h3 class="ibk-title partner-title">Datos del socio {{ i + 1 }}</h3>
    <button
      *ngIf="i > 1"
      (click)="removePartnerRequest.emit(i)"
      class="ibk-btn ibk-btn--medium-font ibk-btn--accent ibk-btn--borderless ibk-btn--no-bg remove"
    >
      Remover socio
    </button>
  </div>
  <div class="ba-field-group">
    <ibk-input-group>
      <label>Tipo de documento (*)</label>
      <ibk-select dsRxForm="selectChange" formControlName="documentType" class="field">
        <ibk-select-option [value]="DocumentType.DNI"></ibk-select-option>
        <ibk-select-option [value]="DocumentType.CE"></ibk-select-option>
      </ibk-select>
    </ibk-input-group>
    <ibk-input-group>
      <label>Número de documento (*)</label>
      <ibk-input class="field" char-filter="^[0-9]{1,8}$">
        <input
          class="field"
          formControlName="documentNumber"
          [attr.maxLength]="pForm.controls.documentType.value === DocumentType.DNI ? '8' : '11'"
        />
      </ibk-input>
    </ibk-input-group>
  </div>

  <div class="ba-field-group">
    <ibk-input class="field">
      <input class="field" type="checkbox" (change)="chkPepNewPepPartner($event, i)" formControlName="isPEP"/>
      El socio {{ i + 1 }} es una Persona Expuesta Pol&iacute;ticamente (PEP)
    </ibk-input>
  </div>

  <ng-container *ngIf="pForm.get('pepPartnerList')" formGroupName="pepPartnerList">
    <ba-pep-partners-list-form></ba-pep-partners-list-form>
  </ng-container>

  <ng-container *ngIf="getCEDataForm(pForm) as CEDataForm" [formGroup]="CEDataForm">
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Primer nombre</label>
        <ibk-input class="field">
          <input class="field" formControlName="firstName" maxlength="20" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Segundo nombre</label>
        <ibk-input class="field">
          <input class="field" formControlName="secondName" maxlength="20" />
        </ibk-input>
      </ibk-input-group>
    </div>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Apellido paterno</label>
        <ibk-input class="field">
          <input class="field" formControlName="lastName" maxlength="20" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Apellido materno</label>
        <ibk-input class="field">
          <input class="field" formControlName="motherLastName" maxlength="20" />
        </ibk-input>
      </ibk-input-group>
    </div>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>País de nacimiento</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="birthCountry">
          <ibk-select-option
            *ngFor="let option of paramsService.params$('country') | async"
            [value]="option.value"
            [label]="option.label"
          ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <ibk-input-group>
        <label>País de nacionalidad</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="nationality">
          <ibk-select-option
            *ngFor="let option of paramsService.params$('country') | async"
            [value]="option.value"
            [label]="option.label"
          ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
    </div>

    <h3 class="ibk-title">Dirección legal</h3>
    <ng-container [formGroup]="getAddressForm(CEDataForm)">
      <ba-address-form></ba-address-form>
    </ng-container>
  </ng-container>
</ng-container>

<div class="actions">
  <button
    [disabled]="partnerList().length >= maxPartnersSize"
    (click)="newPartnerRequest.emit()"
    class="ibk-btn ibk-btn--medium-font ibk-btn--primary ibk-btn--borderless ibk-btn--no-bg add"
  >
    <span class="material-icons ibk-icon ibk-icon--circled ibk-icon--within-action"> add </span>
    Añadir otro socio
  </button>
</div>
<div class="ba-field-group">
  <ibk-input class="field">
    <!-- [formControl]="$any(form.get('isSameAddressCompanyAndLegalRepresentant'))" -->
    <input class="field" type="checkbox" />
    Declaro haber ingresado todos los accionistas que conforman la empresa.
  </ibk-input>
</div>
<ibk-toast type="WARN" *ngIf="partnerList().length >= maxPartnersSize">
  Si tu empresa está conformada por más de {{ maxPartnersSize }} socios deberás crear una Cuenta corriente Empresas.
  <a href="#" class="ibk-link"> Solicítala aquí </a>
</ibk-toast>